import { clamp } from "../style/clamp-calculator";

function pxToRem(value: number) {
  return `${value / 16}rem`;
}

declare module "@mui/material/styles" {
  interface TypographyVariants {
    fontWeightSemiBold: React.CSSProperties["fontWeight"];
  }
  interface TypographyVariantsOptions {
    fontWeightSemiBold?: React.CSSProperties["fontWeight"];
  }
}

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    // allow custom weights if needed
  }
}

export const typography = {
  fontFamily: "Hanken Grotesk, sans-serif",

  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,

  h1: {
    fontFamily: "Hanken Grotesk",
    fontWeight: 400,
    lineHeight: 80 / 64,
    fontSize: clamp.calculate(40, 64),
  },
  h2: {
    fontFamily: "Hanken Grotesk",
    fontWeight: 400,
    lineHeight: 64 / 48,
    fontSize: clamp.calculate(32, 48),
  },
  h3: {
    fontFamily: "Hanken Grotesk",
    fontWeight: 400,
    lineHeight: 48 / 32,
    fontSize: clamp.calculate(24, 32),
  },
  h4: {
    fontFamily: "Hanken Grotesk",
    fontWeight: 400,
    lineHeight: 36 / 24,
    fontSize: clamp.calculate(20, 24),
  },
  h5: {
    fontFamily: "Hanken Grotesk",
    fontWeight: 400,
    lineHeight: 30 / 20,
    fontSize: clamp.calculate(18, 20),
  },
  h6: {
    fontFamily: "Hanken Grotesk",
    fontWeight: 400,
    lineHeight: 28 / 18,
    fontSize: clamp.calculate(16, 18),
  },

  subtitle1: {
    fontFamily: "Hanken Grotesk",
    fontWeight: 600,
    lineHeight: 24 / 16,
    fontSize: pxToRem(16),
  },
  subtitle2: {
    fontFamily: "Hanken Grotesk",
    fontWeight: 600,
    lineHeight: 22 / 14,
    fontSize: pxToRem(14),
  },

  body1: {
    fontFamily: "Hanken Grotesk",
    fontWeight: 400,
    lineHeight: 24 / 16,
    fontSize: pxToRem(16),
  },
  body2: {
    fontFamily: "Hanken Grotesk",
    fontWeight: 400,
    lineHeight: 22 / 14,
    fontSize: pxToRem(14),
  },

  caption: {
    fontFamily: "Hanken Grotesk",
    fontWeight: 400,
    lineHeight: 18 / 12,
    fontSize: pxToRem(12),
  },
  overline: {
    fontFamily: "Hanken Grotesk",
    fontWeight: 700,
    lineHeight: 18 / 12,
    fontSize: pxToRem(12),
    textTransform: "uppercase",
  },
  button: {
    fontFamily: "Hanken Grotesk",
    fontWeight: 500,
    lineHeight: 26 / 15,
    fontSize: pxToRem(15),
    textTransform: "unset",
  },
} as const;
